import { useLazyGetLastChangeLogQuery } from "@/src-refactor/modules/store/qrtk/services/realestate/realestate.qrtk";
import { RealEstateChangeLogResponseRTKQ } from "@/src-refactor/modules/store/qrtk/services/realestate/values/changeLog.realestate.value";
import { Grid, styled } from "@mui/material";
import { MxChangeLogAddAndRemoveArrow } from "@rf-l1/page/details/change-log/MxChangeLogAddAndRemoveArrow";
import { MxChangeLogArrow } from "@rf-l1/page/details/change-log/MxChangeLogArrow";
import MxChangeLogDeepArrow from "@rf-l1/page/details/change-log/MxChangeLogDeepArrow";
import { MxChangeLogPlainArrow } from "@rf-l1/page/details/change-log/MxChangeLogPlainArrow";
import MxEmptyBody from "@rf-l1/empty-sections/MxEmptyBody";
import MxEmptyCard from "@rf-l1/empty-sections/MxEmptyCard";
import MxEmptyIcon from "@rf-l1/empty-sections/MxEmptyIcon";
import MxLoading from "@rf-l1/loading/MxLoading";
import MxTypography from "@rf-l1/MxTypography";
import MxDetailCard from "@rf-l1/page/details/MxDetailCard";
import MxDetailSubTitle from "@rf-l1/page/details/MxDetailSubTitle";
import { MxRenderDetailTemplate } from "@rf-l1/page/details/MxRenderDetailTemplate";
import MxPagination from "@rf-l1/page/list/MxPaginations";
import ProperChangeLogAdapter from "@rf/property/module/adapters/propertyChangeLog.adapter";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { HToastCatchServerError } from "@rf-helper/cath-error-server";

function PropertyDetailChangeLog() {
  const { DATAlOG, handleChangePage } = useUsePropertyChangeLog();
  if (!DATAlOG?.data?.data?.length) return null;

  return (
    <MxDetailCard>
      <MxRenderDetailTemplate
        data={Boolean(DATAlOG?.data?.data?.length)}
        status={DATAlOG?.status}
        template={<Template data={DATAlOG?.data?.data} />}
        errorTemplate={
          <MxEmptyCard size="section">
            <MxEmptyIcon variant="error" />
            <MxEmptyBody>
              Ah ocurrido un incoveniente al cargar los últimos cambios
            </MxEmptyBody>
          </MxEmptyCard>
        }
        loadingTemplate={
          <MxEmptyCard size="section">
            <MxLoading variant="gradient" />
          </MxEmptyCard>
        }
        emptyTemplate={
          <MxEmptyCard size="section">
            <MxEmptyIcon variant="info" />
            <MxEmptyBody>No se han registrado cambios en esta propiedad</MxEmptyBody>
          </MxEmptyCard>
        }
      />

      {DATAlOG?.data?.meta && (
        <MxPagination
          page={DATAlOG?.data?.meta?.current_page}
          totalPages={DATAlOG?.data?.meta?.last_page}
          onChangePage={handleChangePage}
        />
      )}
    </MxDetailCard>
  );
}

export default PropertyDetailChangeLog;

const Template = (props: {
  data: RealEstateChangeLogResponseRTKQ["data"] | undefined;
}) => {
  const dataT = ProperChangeLogAdapter(props.data);
  return (
    <Grid container rowGap={2}>
      <Grid item xs={12}>
        <MxDetailSubTitle label="Historial de cambios" />
      </Grid>
      <Grid
        container
        item
        xs={12}
        rowGap={1}
        maxHeight={500}
        overflow={"auto"}
        id="PropertyDetailChangeLogId"
      >
        {dataT.map((x, i) => (
          <MainContentChange container item xs={12} key={i} rowGap={2}>
            <Grid container item xs={12} gap={1}>
              <Grid item xs="auto">
                <MxTypography color="grey.700" variant="caption">
                  {x.author}
                </MxTypography>
              </Grid>
              <Grid item xs="auto">
                <MxTypography color="grey.700" variant="caption" fontWeight={500}>
                  ha actualizado: {x.date}
                </MxTypography>
              </Grid>
            </Grid>

            <Grid container px={1} rowGap={0.5}>
              {x.changes.map((c, i) => (
                <Grid item xs={12} key={i}>
                  {c.type == "arrow" && (
                    <MxChangeLogArrow
                      title={c.label}
                      fromText={c.data?.old}
                      toText={c.data?.new}
                    />
                  )}
                  {c.type == "plainTextArrow" && (
                    <MxChangeLogPlainArrow
                      title={c.label}
                      fromText={c.data?.old}
                      toText={c.data?.new}
                    />
                  )}
                  {c.type == "deepArrow" && (
                    <MxChangeLogDeepArrow title={c.label} changes={c.data} key={i} />
                  )}

                  {c.type == "addAndRemoveArrow" && (
                    <MxChangeLogAddAndRemoveArrow
                      label={c.label}
                      changes={c.data}
                      key={i}
                    />
                  )}
                  {c.type == "no-soporte" && (
                    <MxTypography variant="overline" color="primary.main">
                      No soporte
                    </MxTypography>
                  )}
                </Grid>
              ))}
            </Grid>
          </MainContentChange>
        ))}
      </Grid>
    </Grid>
  );
};

const useUsePropertyChangeLog = () => {
  const { id } = useParams();

  const [GET_LAST_CHANGES_M, GET_LAST_CHANGES_DATA] = useLazyGetLastChangeLogQuery();

  const handleChangePage = (page: number) => {
    if (id) {
      GET_LAST_CHANGES_M({
        params: {
          id: id
        },
        query: {
          page: page
        }
      })
        .unwrap()
        .then(() => {
          const content = document.getElementById("PropertyDetailChangeLogId");
          content?.scroll({
            top: 0,
            behavior: "smooth"
          });
        })
        .catch(e => HToastCatchServerError(e));
    }
  };

  useEffect(() => {
    if (id) {
      GET_LAST_CHANGES_M({
        params: {
          id: id
        },
        query: {
          page: 1
        }
      });
    }
  }, [id]);

  return {
    handleChangePage,
    DATAlOG: GET_LAST_CHANGES_DATA
  };
};
const MainContentChange = styled(Grid)(({ theme }) => ({
  "&:hover": {
    backgroundColor: "#eff6ff"
  },
  transition: "0.2s",
  borderRadius: 5,
  padding: 7,
  marginRight: 5
}));
